module.exports = __webpack_public_path__ + "static/media/assembly9.9e36a423.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/gameRocketRepair/assembly9.png
// module id = 2427
// module chunks = 0